import { DefinitionSection } from './view';
export default DefinitionSection;
